import { Constants } from '@constants';
import {
    IconCheckDefault,
    IconQuestionMarkFilled,
    IconPhoneFilled,
    IconEmailFilled
} from '@iwoca/icons';
import { Accordion, IwocaLogo, Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { TrustPilot } from '../../../TrustPilot/TrustPilot';

export const Sidebar = () => {
    return (
        <div className="h-screen overflow-hidden bg-primary-20 p-0">
            <div className="flex flex-col gap-l p-3xl">
                <Text className="text-3xl font-med text-structure-100">
                    <FormattedMessage
                        id="_.credit_card.sidebar.title"
                        defaultMessage="Get your iwoca credit card today"
                    />
                </Text>

                <div className="text-m text-structure-100">
                    <ul className="flex flex-col gap-m">
                        <li className="flex flex-row gap-s">
                            <IconCheckDefault className="my-auto text-success-mid" />
                            <FormattedMessage
                                id="_.credit_card.sidebar.highlight.cashback"
                                defaultMessage="1% cashback on every transaction"
                            />
                        </li>
                        <li className="flex flex-row gap-s">
                            <IconCheckDefault className="my-auto text-success-mid" />
                            <FormattedMessage
                                id="_.credit_card.sidebar.highlight.virtual_card"
                                defaultMessage="Instant start with a virtual card"
                            />
                        </li>
                        <li className="flex flex-row gap-s">
                            <IconCheckDefault className="my-auto text-success-mid" />
                            <FormattedMessage
                                id="_.credit_card.sidebar.highlight.no_forex"
                                defaultMessage="No foreign exchange fees when spending abroad"
                            />
                        </li>
                        <li className="flex flex-row gap-s">
                            <IconCheckDefault className="my-auto text-success-mid" />
                            <FormattedMessage
                                id="_.credit_card.sidebar.highlight.mobile_app"
                                defaultMessage="Mobile app to manage everything"
                            />
                        </li>
                    </ul>
                </div>

                <Accordion
                    data-testid="credit-card-accordion-container"
                    frame={false}
                    small
                    className="bg-transparent text-structure-100"
                    title={
                        <Text className="text-s font-med text-structure-100">
                            <FormattedMessage
                                id="_.credit_card.sidebar.highlight.need_help"
                                defaultMessage="Still need help?"
                            />
                        </Text>
                    }
                >
                    <ul className="flex flex-col gap-xs">
                        <li className="flex flex-row gap-s">
                            <IconQuestionMarkFilled className="my-auto text-structure-100" />
                            <FormattedMessage
                                id="_.credit_card.sidebar.help.FAQ"
                                defaultMessage="Find answers in our <a>FAQ</a>"
                                values={{
                                    a: (chunks) => (
                                        <a href={'/faq'}>
                                            <strong>{chunks}</strong>
                                        </a>
                                    )
                                }}
                            />
                        </li>

                        <li className="flex flex-col">
                            <p className="flex flex-row gap-x-s">
                                <IconPhoneFilled className="my-auto text-structure-100" />
                                <FormattedMessage
                                    id="_.credit_card.sidebar.help.call"
                                    defaultMessage="Call us on <a>{phone}</a>"
                                    values={{
                                        phone: Constants.PHONE_NUMBER.display,
                                        a: (chunks) => (
                                            <a
                                                href={`tel:${Constants.PHONE_NUMBER.tel}`}
                                            >
                                                <strong>{chunks}</strong>
                                            </a>
                                        )
                                    }}
                                />
                            </p>
                            <p className="mt-[-10px]">
                                <FormattedMessage
                                    id="_.credit_card.sidebar.help.open_times"
                                    defaultMessage="Monday to Friday 9am - 6pm (excluding bank holidays)"
                                />
                            </p>
                        </li>

                        <li className="flex flex-row">
                            <IconEmailFilled className="col-span-1 my-auto text-structure-100" />
                            <FormattedMessage
                                id="_.credit_card.sidebar.help.email"
                                defaultMessage="Email us at <a> {email}</a> "
                                values={{
                                    email: Constants.EMAIL,
                                    a: (chunks) => (
                                        <a href={`mailto:${Constants.EMAIL}`}>
                                            <strong>{chunks}</strong>
                                        </a>
                                    )
                                }}
                            />
                        </li>
                    </ul>
                </Accordion>

                <div className="flex flex-col justify-center text-center">
                    <IwocaLogo className="m-auto h-5xl w-5xl" color="white" />
                    <TrustPilot theme="dark" />
                </div>
            </div>
        </div>
    );
};
